import { createRouter, createWebHistory } from 'vue-router';
import API from '../api/index.js';
function authenticateUser(to, from, next, redirectOnSuccess = null, allowRedirectToLogin = true) {
  const isAuthenticated = localStorage.getItem('user_token');

  if (!isAuthenticated) {
    if (allowRedirectToLogin && to.path !== '/login') {
      return next('/login');
    } else {
      return next();
    }
  } else {
    if (redirectOnSuccess) {
      return next(redirectOnSuccess);
    } else {
      return next();
    }
  }
}

async function authenticateAdmin(to, from, next, redirectOnSuccess = null) {
  const isAuthenticated = localStorage.getItem('admin_token');
  if (!isAuthenticated) {
    return next('/adminlogin');
  }
  else {
    if (localStorage.getItem('admin_login_info')) {
      const loginInfo = JSON.parse(localStorage.getItem('admin_login_info'));
      const response = await API.checkAdminStatus(loginInfo)
      if (response.data.code === 200) {
        const role = parseInt(response.data.result.role);
        const status = parseInt(response.data.result.status);
        
        if (role === 4) {
          if (status === 1) {
            return next('/adminlogin');
          }
        } else {
          if (status === 1) {
            return next('/adminlogin');
          }
        }
        
        if (role === 4 && to.path.startsWith('/service/')) {
          if (to.path !== '/service/staff' && to.path !== '/service/workorders') {
            return next('/service/workorders');
          }
        }
        
        if (redirectOnSuccess) {
          return next(redirectOnSuccess);
        } else {
          return next();
        }
      } else {
        return next('/adminlogin');
      }
    } else {
      return next('/adminlogin');
    }

  }
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomePage.vue'),  //动态加载组件
    beforeEnter: (to, from, next) => {
      authenticateUser(to, from, next, null, false)
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginPage.vue'),  //动态加载组件
    beforeEnter: (to, from, next) => {
      authenticateUser(to, from, next, null, false)
    }
  },
  { path: '/adminlogin', name: 'AdminLogin', component: () => import('../backend-views/AdminLoginPage.vue') },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/RegisterPage.vue')
  },
  {
    path: '/discover',
    name: 'DisCover',
    component: () => import('../views/DiscoverPage.vue'),
  },
  {
    path: '/article',
    name: 'ArticlePage',
    component: () => import('../views/ArticlePage.vue'),
  },
  {
    path: '/detail/:id',
    name: 'DetailPage',
    component: () => import('../views/DetailPage.vue'),
  },
  {
    path: '/goodslist',
    name: 'GoodsList',
    component: () => import('../views/GoodsList.vue'),
  },
  {
    path: '/shopcart',
    name: 'ShopCart',
    component: () => import('../views/ShopCart.vue'),
    beforeEnter: (to, from, next) => {
      authenticateUser(to, from, next)
    }
  },
  {
    path: '/my',
    name: 'MyPage',
    component: () => import('../views/MyPage.vue'),
    beforeEnter: (to, from, next) => {
      authenticateUser(to, from, next)
    }
  },
  {
    path: '/checkout',
    name: 'CheckOut',
    component: () => import('../views/CheckOut.vue'),
    beforeEnter: (to, from, next) => {
      authenticateUser(to, from, next)
    }
  },
  {
    path: '/servicelist',
    name: 'ServiceList',
    component: () => import('../views/ServiceList.vue'),
  },
  { path: '/todaymenu', 
    name: 'todaymenu', 
    component: () => import('../views/TodayMenuPage.vue'), 
    beforeEnter: (to, from, next) => { 
      // 允许游客访问，不强制重定向到登录页面
      authenticateUser(to, from, next, null, false) 
    } 
  },
  { 
    path: '/interview', 
    name: 'InterView', 
    component: () => import('../views/InterViewPage.vue'),
    beforeEnter: (to, from, next) => {
      authenticateUser(to, from, next)
    }
  },
  { 
    path: '/interview-records', 
    name: 'InterviewRecords', 
    component: () => import('../views/InterviewRecords.vue'),
    beforeEnter: (to, from, next) => {
      authenticateUser(to, from, next)
    }
  },
  {
    path: '/orderlist',
    name: 'orderlist',
    component: () => import('../views/OrderListPage.vue'),
    beforeEnter: (to, from, next) => {
      authenticateUser(to, from, next)
    }
  },
  {
    path: '/admintodayorder',
    name: 'admintodayorder',
    component: () => import('../backend-views/AdminTodayOrderPage.vue'),
    beforeEnter: (to, from, next) => {
      authenticateAdmin(to, from, next)
    }
  },
  {
    path: '/deliveryorder',
    name: 'deliveryorder',
    component: () => import('../backend-views/DeliveryOrderPage.vue'),
    beforeEnter: (to, from, next) => {
      authenticateAdmin(to, from, next)
    }
  },
  {
    path: '/canteen',
    name: 'CanteenLayout',
    component: () => import('../components/CanteenLayout.vue'),
    beforeEnter: (to, from, next) => {
      authenticateAdmin(to, from, next)
    },
    children: [
      {
        path: 'home',
        name: 'CanteenHome',
        component: () => import('../canteen-views/CanteenHome.vue')
      },
      {
        path: 'user',
        name: 'CanteenUser',
        component: () => import('../canteen-views/CanteenUser.vue')
      },
      {
        path: 'order',
        name: 'CanteenOrder',
        component: () => import('../canteen-views/CanteenOrder.vue')
      },
      {
        path: 'finance',
        name: 'CanteenFinance',
        component: () => import('../canteen-views/CanteenFinance.vue')
      },
      {
        path: 'recharge',
        name: 'CanteenRecharge',
        component: () => import('../canteen-views/CanteenRecharge.vue')
      }
    ]
  },
  {
    path: '/admin',
    name: 'AdminLayout',
    component: () => import('@/components/AdminLayout.vue'),
    beforeEnter: (to, from, next) => {
      authenticateAdmin(to, from, next)
    },
    children: [
      {
        path: 'home',
        component: () => import('@/admin-views/AdminHome.vue'),
        name: 'AdminHome'
      },
      {
        path: 'imagecategory',
        component: () => import('@/admin-views/AdminImageCategory.vue'),
        name: 'AdminImageCategory'
      },
      {
        path: 'imagemanage',
        component: () => import('@/admin-views/AdminImageManage.vue'),
        name: 'AdminImageManage'
      },
      {
        path: 'banners',
        component: () => import('@/admin-views/AdminBanners.vue'),
        name: 'AdminBanners'
      },
      {
        path: 'moreservices',
        component: () => import('@/admin-views/AdminMoreServices.vue'),
        name: 'AdminMoreServices'
      },
      {
        path: 'weixinqun',
        component: () => import('@/admin-views/AdminWeixinQun.vue'),
        name: 'AdminWeixinQun'
      },
      {
        path: 'area',
        component: () => import('@/admin-views/AreaManage.vue'),
        name: 'AreaManage'
      },
      {
        path: 'shoptype',
        component: () => import('@/admin-views/AdminShopType.vue'),
        name: 'AdminShopType'
      },
      {
        path: 'addshop',
        component: () => import('@/admin-views/AdminAddShop.vue'),
        name: 'AdminAddShop'
      },
      {
        path: 'users',
        component: () => import('@/admin-views/AdminUsers.vue'),
        name: 'AdminUsers'
      },
      {
        path: 'property',
        component: () => import('@/admin-views/AdminProperty.vue'),
        name: 'AdminProperty'
      },
      {
        path: 'rechargelist',
        component: () => import('@/admin-views/AdminRechargeList.vue'),
        name: 'AdminRechargeList'
      },
      {
        path: 'balance-transactions',
        component: () => import('@/admin-views/AdminBalanceTransactions.vue'),
        name: 'AdminBalanceTransactions'
      },
      {
        path: 'orderlist',
        component: () => import('@/admin-views/AdminOrderList.vue'),
        name: 'AdminOrderList'
      },
      {
        path: 'export',
        component: () => import('@/admin-views/AdminExport.vue'),
        name: 'AdminExport'
      },
      {
        path: 'shopmenu',
        component: () => import('@/admin-views/AdminShopMenu.vue'),
        name: 'AdminShopMenu'
      },
      {
        path: 'memberlevel',
        component: () => import('@/admin-views/AdminMemberLevel.vue'),
        name: 'AdminMemberLevel'
      },
      {
        path: 'butlers',
        component: () => import('@/admin-views/ButlerManagement.vue'),
        name: 'ButlerManagement'
      },
      {
        path: 'butler-detail/:id',
        component: () => import('@/admin-views/ButlerDetail.vue'),
        name: 'ButlerDetail'
      },
      {
        path: 'butler-customers',
        component: () => import('@/admin-views/ButlerCustomers.vue'),
        name: 'ButlerCustomers'
      },
      {
        path: 'butler-orders',
        component: () => import('@/admin-views/ButlerOrders.vue'),
        name: 'ButlerOrders'
      },
      {
        path: 'butler-income',
        component: () => import('@/admin-views/ButlerIncome.vue'),
        name: 'ButlerIncome'
      },
      {
        path: 'butler-commission-payout',
        component: () => import('@/admin-views/ButlerIncome.vue'),
        name: 'ButlerCommissionPayout',
        meta: { payout: true }
      },
      {
        path: 'butler-follow-records',
        component: () => import('@/admin-views/ButlerFollowRecords.vue'),
        name: 'ButlerFollowRecords'
      },
      {
        path: 'butler-register-consents',
        component: () => import('@/admin-views/ButlerRegisterConsents.vue'),
        name: 'ButlerRegisterConsents'
      },
      {
        path: 'butler-public-users',
        component: () => import('@/admin-views/ButlerPublicUsers.vue'),
        name: 'ButlerPublicUsers'
      },
      {
        path: 'butler-performance/:id',
        component: () => import('@/admin-views/ButlerPerformance.vue'),
        name: 'ButlerPerformance'
      },
      {
        path: 'manage',
        component: () => import('@/admin-views/AdminManage.vue'),
        name: 'AdminManage'
      },
      {
        path: 'shopprinter',
        component: () => import('@/admin-views/AdminShopPrinter.vue'),
        name: 'AdminShopPrinter'
      },
      {
        path: 'finance',
        component: () => import('@/admin-views/AdminFinance.vue'),
        name: 'AdminFinance'
      },
      { path: '/admin/articlecategory', name: 'adminArticleCategory', component: () => import('../admin-views/AdminArticleCategory.vue') },
      { path: '/admin/articlelist', name: 'adminArticleList', component: () => import('../admin-views/AdminArticleList.vue') },
      { path: '/admin/addarticle', name: 'adminAddArticle', component: () => import('../admin-views/AdminAddArticle.vue') },
      { path: '/admin/signupmanagement', name: 'adminSignupManagement', component: () => import('../admin-views/AdminSignupManagement.vue') },
      { path: '/admin/checkinstats', name: 'adminCheckinStats', component: () => import('../admin-views/AdminCheckinStats.vue') },
      { path: '/admin/commentmanagement', name: 'adminCommentManagement', component: () => import('../admin-views/AdminCommentManagement.vue') },
      { path: '/admin/homenoticemanagement', name: 'HomeNotificationManagement', component: () => import('../admin-views/HomeNotificationManagement.vue') },
      { path: '/admin/wxpayorder', name: 'adminWxPayOrder', component: () => import('../admin-views/AdminWxPayOrder.vue') },
      { path: '/admin/bill', name: 'adminBill', component: () => import('../admin-views/AdminBill.vue') },
      { path: '/admin/systemparams', name: 'adminSystemParams', component: () => import('../admin-views/AdminSystemParams.vue') },
      { path: '/admin/wxsubscribetemplates', name: 'adminWxSubscribeTemplates', component: () => import('../admin-views/WxSubscribeTemplates.vue') },
      { path: '/admin/mppushsettings', name: 'adminMpPushSettings', component: () => import('../admin-views/MpPushSettings.vue') },
      {
        path: 'meal-activity-create',
        component: () => import('@/admin-views/MealActivityCreate.vue'),
        name: 'MealActivityCreate'
      },
      {
        path: 'meal-activity-list',
        component: () => import('@/admin-views/MealActivityList.vue'),
        name: 'MealActivityList'
      }
    ]
  },
  {
    path: '/mall',
    name: 'MallLayout',
    component: () => import('@/components/MallLayout.vue'),
    redirect: '/mall/productlist',
    beforeEnter: (to, from, next) => {
      authenticateAdmin(to, from, next)
    },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/mall-views/MallDataBoard.vue'),
        name: 'MallDataBoard'
      },
      {
        path: 'productlist',
        component: () => import('@/mall-views/AdminProductList.vue'),
        name: 'AdminProductList'
      },
      {
        path: 'productcategory',
        component: () => import('@/mall-views/AdminProductCategory.vue'),
        name: 'AdminProductCategory'
      },
      {
        path: 'addproduct',
        component: () => import('@/mall-views/AdminAddProduct.vue'),
        name: 'AdminAddProduct'
      },
      {
        path: 'updateproduct/:id',
        component: () => import('@/mall-views/AdminUpdateProduct.vue'),
        name: 'AdminUpdateProduct'
      },
      {
        path: 'skus',
        component: () => import('@/mall-views/ProductSkuManagement.vue'),
        name: 'ProductSkuManagement'
      },
      {
        path: 'reviews',
        component: () => import('@/mall-views/MallReviewManagement.vue'),
        name: 'MallReviewManagement'
      },
      {
        path: 'orders',
        component: () => import('@/mall-views/MallOrderList.vue'),
        name: 'MallOrderList'
      },
      {
        path: 'logistics',
        component: () => import('@/mall-views/LogisticsTemplateManagement.vue'),
        name: 'LogisticsTemplateManagement'
      },
      {
        path: 'pickuppoints',
        component: () => import('@/mall-views/PickupPointManagement.vue'),
        name: 'PickupPointManagement'
      },
      {
        path: 'couriercompanies',
        component: () => import('@/mall-views/CourierCodeManagement.vue'),
        name: 'CourierCodeManagement'
      },
      {
        path: 'aftersales',
        component: () => import('@/mall-views/MallAfterSaleList.vue'),
        name: 'MallAfterSaleList'
      },
      {
        path: 'returnaddresses',
        component: () => import('@/mall-views/ReturnAddressManagement.vue'),
        name: 'ReturnAddressManagement'
      },
      {
        path: 'suppliers',
        component: () => import('@/mall-views/SupplierManagement.vue'),
        name: 'SupplierManagement'
      },
      {
        path: 'activities',
        component: () => import('@/mall-views/MallActivitiesManagement.vue'),
        name: 'MallActivitiesManagement'
      },
      {
        path: 'discounts',
        component: () => import('@/mall-views/MallDiscountPlansManagement.vue'),
        name: 'MallDiscountPlansManagement'
      },
      {
        path: 'zonetabs',
        component: () => import('@/mall-views/MallZoneTabManagement.vue'),
        name: 'MallZoneTabManagement'
      }
    ]
  },
  {
    path: '/databoard',
    name: 'DataBoard',
    component: () => import('../views/DataBoard.vue')
  },
  {
    path: '/global-data-board',
    name: 'GlobalDataBoard',
    component: () => import('../views/GlobalDataBoard.vue')
  },
  {
    // 管家业绩数据大屏：整屏独立页面，可直接通过网址访问
    path: '/butler-dashboard',
    name: 'ButlerDashboard',
    component: () => import('../views/ButlerDashboard.vue')
  },
  {
    path: '/service',
    name: 'ServiceLayout',
    component: () => import('@/components/ServiceLayout.vue'),
    beforeEnter: (to, from, next) => {
      authenticateAdmin(to, from, next)
    },
    children: [
      {
        path: 'management',
        component: () => import('@/service-views/ServiceManagement.vue'),
        name: 'ServiceManagement'
      },
      {
        path: 'types',
        component: () => import('@/service-views/ServiceTypeManagement.vue'),
        name: 'ServiceTypeManagement'
      },
      {
        path: 'membership',
        component: () => import('@/service-views/MembershipManagement.vue'),
        name: 'MembershipManagement'
      },
      {
        path: 'membership-approvals',
        component: () => import('@/service-views/MembershipChangeApproval.vue'),
        name: 'MembershipChangeApproval'
      },
      {
        path: 'orders',
        component: () => import('@/service-views/OrderManagement.vue'),
        name: 'OrderManagement'
      },
      {
        path: 'order-tracking',
        component: () => import('@/service-views/OrderTracking.vue'),
        name: 'OrderTracking'
      },
      {
        path: 'quota',
        component: () => import('@/service-views/QuotaManagement.vue'),
        name: 'QuotaManagement'
      },
      {
        path: 'quota-audit',
        component: () => import('@/service-views/QuotaAuditLog.vue'),
        name: 'QuotaAuditLog'
      },
      {
        path: 'coupons',
        component: () => import('@/service-views/CouponManagement.vue'),
        name: 'CouponManagement'
      },
      {
        path: 'referral',
        component: () => import('@/service-views/ReferralManagement.vue'),
        name: 'ReferralManagement'
      },
      {
        path: 'diamond',
        component: () => import('@/service-views/DiamondPlanManagement.vue'),
        name: 'DiamondPlanManagement'
      },
      {
        path: 'report',
        component: () => import('@/service-views/DataReport.vue'),
        name: 'DataReport'
      },
      {
        path: 'sku',
        component: () => import('@/service-views/ServiceSkuManagement.vue'),
        name: 'ServiceSkuManagement'
      },
      {
        path: 'discounts',
        component: () => import('@/service-views/DiscountManagement.vue'),
        name: 'DiscountManagement'
      },
      {
        path: 'providers',
        component: () => import('@/service-views/ServiceProviderManagement.vue'),
        name: 'ServiceProviderManagement'
      },
      {
        path: 'staff',
        component: () => import('@/service-views/ServiceStaffManagement.vue'),
        name: 'ServiceStaffManagement'
      },
      {
        path: 'workorders',
        component: () => import('@/service-views/WorkOrderManagement.vue'),
        name: 'WorkOrderManagement'
      },
      {
        path: 'purchase-record',
        component: () => import('@/service-views/MembershipPurchaseRecord.vue'),
        name: 'MembershipPurchaseRecord'
      },
      {
        path: 'knowledge-base',
        component: () => import('@/service-views/KnowledgeBaseManagement.vue'),
        name: 'KnowledgeBaseManagement'
      },
      {
        path: 'ai-chat-records',
        component: () => import('@/service-views/AiChatRecords.vue'),
        name: 'AiChatRecords'
      },
      {
        path: 'health-records',
        component: () => import('@/service-views/HealthRecordManagement.vue'),
        name: 'HealthRecordManagement'
      },
      {
        path: 'visit-records',
        component: () => import('@/service-views/VisitRecordManagement.vue'),
        name: 'VisitRecordManagement'
      },
      {
        path: 'scope',
        component: () => import('@/service-views/ServiceScopeManagement.vue'),
        name: 'ServiceScopeManagement'
      },
      {
        path: 'emergency-calls',
        component: () => import('@/service-views/EmergencyCallRecords.vue'),
        name: 'EmergencyCallRecords'
      },
      {
        path: 'timeout-logs',
        component: () => import('@/service-views/TimeoutLogs.vue'),
        name: 'TimeoutLogs'
      },
      {
        path: 'provider-breaches',
        component: () => import('@/service-views/ProviderBreaches.vue'),
        name: 'ProviderBreaches'
      },
      {
        path: 'compensations',
        component: () => import('@/service-views/Compensations.vue'),
        name: 'Compensations'
      }
    ]
  },
  {
    path: '/qyys',
    name: 'QyysLayout',
    component: () => import('@/components/QyysLayout.vue'),
    redirect: '/qyys/dashboard',
    beforeEnter: (to, from, next) => {
      authenticateAdmin(to, from, next)
    },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/qyys-views/QyysDashboard.vue'),
        name: 'QyysDashboard'
      },
      {
        path: 'articles',
        component: () => import('@/qyys-views/QyysArticleManagement.vue'),
        name: 'QyysArticleManagement'
      },
      {
        path: 'pillars',
        component: () => import('@/qyys-views/QyysPillarManagement.vue'),
        name: 'QyysPillarManagement'
      },
      {
        path: 'comments',
        component: () => import('@/qyys-views/QyysCommentManagement.vue'),
        name: 'QyysCommentManagement'
      },
      {
        path: 'circles',
        component: () => import('@/qyys-views/QyysCircleManagement.vue'),
        name: 'QyysCircleManagement'
      },
      {
        path: 'activities',
        component: () => import('@/qyys-views/QyysActivityManagement.vue'),
        name: 'QyysActivityManagement'
      },
      {
        path: 'orders',
        component: () => import('@/qyys-views/QyysOrderManagement.vue'),
        name: 'QyysOrderManagement'
      },
      {
        path: 'posts',
        component: () => import('@/qyys-views/QyysPostAudit.vue'),
        name: 'QyysPostAudit'
      },
      {
        path: 'monitor-applies',
        component: () => import('@/qyys-views/QyysMonitorApplyAudit.vue'),
        name: 'QyysMonitorApplyAudit'
      },
      {
        path: 'members',
        component: () => import('@/qyys-views/QyysMemberManagement.vue'),
        name: 'QyysMemberManagement'
      },
      {
        path: 'config',
        component: () => import('@/qyys-views/QyysConfigManagement.vue'),
        name: 'QyysConfigManagement'
      },
      {
        path: 'reports',
        component: () => import('@/qyys-views/QyysReportManagement.vue'),
        name: 'QyysReportManagement'
      },
      {
        path: 'resumes',
        component: () => import('@/qyys-views/QyysResumeManagement.vue'),
        name: 'QyysResumeManagement'
      }
    ]
  }
];

const router = createRouter({
  mode: 'history',
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;